import React from "react";
import { Outlet, useLocation, Link, useParams } from "react-router-dom";
import { Card } from "primereact/card";
import "../../components/entities/entities.scss";
import "../../components/settings/settings.scss";
import "./components/users-access.scss";
import useUserAccess from "./useUserAccess";
import Layout from "../../Layout";
import CustomeButton from "../../components/Button/index";

const UserAccess = () => {
  const { id } = useParams();
  const location = useLocation();
  const activeTab = location.pathname.split("/").pop();
  const { states, handleSelection, handleDiscardUpdate } = useUserAccess(id);
  return (
    <Layout
      title={`Edit ${states.workosuser ? `"${states.workosuser?.first_name} ${states.workosuser?.last_name}"` : ""} access.`}
      subtitle={
        activeTab === "user-service-access"
          ? "Find all the core entity information for your entity"
          : "This section provides a general information about your profile"
      }
      crumbs={[
        { label: "Settings", url: "/settings/my-profile", id: "settings" },
        { label: "Users", url: "/settings/users", id: "users" },
        { label: "Edit User Access", id: "edit-user-access" },
      ]}
    >
      <div className="grid grid-nogutter">
        <div className="col-12 Entities-container">
          <div className="grid">
            <div className="col-3">
              <Card className="card-style p-0">
                <div className="flex flex-column">
                  <Link
                    to={`/settings/users/${id}/user-info`}
                    className={`sidebar-align ${activeTab === "user-info" ? "active-entity" : "menu-hover"}`}
                  >
                    <div className="flex align-items-center">
                      <p className="sidebar-menu">User Information</p>
                    </div>
                    <span className="pi pi-angle-right icon-color"></span>
                  </Link>
                  <Link
                    to={`/settings/users/${id}/user-service-access`}
                    className={`sidebar-align ${activeTab === "user-service-access" ? "active-entity" : "menu-hover"}`}
                  >
                    <div className="flex align-items-center">
                      <p className="sidebar-menu">Entities & Services</p>
                    </div>
                    <span className="pi pi-angle-right icon-color"></span>
                  </Link>
                </div>
              </Card>
            </div>
            <div className="col-9">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserAccess;
